import React from 'react';
import { FormBuilder } from 'commons-ui';

import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, createValidationSchema } from '../../utils/formConfig';

import useCreate from './useCreate';
import { USER_SEGMENTS_STATUS_DOC_PROD } from '../../utils/constants';

const openInNewTab = (url: string) => {
	window.open(url, '_blank', 'noopener,noreferrer');
};

const CreateSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();
	const [css] = useStyletron();
	return (
		<>
			<div
				className={css({
					width: '300px !important',
					marginRight: '20px'
				})}>
				<Button onClick={() => openInNewTab(USER_SEGMENTS_STATUS_DOC_PROD)}>
					User Segments Status Prod. Please check this before creating a new segment.
				</Button>
			</div>
			<FormBuilder
				data={data}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				validationSchema={createValidationSchema}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				dependencies={[]}
			/>
		</>
	);
};

export default CreateSegment;
